<template>
  <NiceView
    :aboveTitle="generalStore.viewHeader"
    :title="CommonService.routes.USERS.title"
    :icon="CommonService.routes.USERS.icon"
    :loading="loading"
    flexBody
  >
    <!-- Filters -->
    <NiceFilters v-model="filtersList" @change="filterChanged" :showCreateButton="permissions.can_manage_users" />

    <!-- Table -->
    <NiceTable
      :actions="actions"
      :columns="columns"
      :data="data"
      :loading="loading"
      freezeLastColumn
      showFooter
      showLimit
      paginated
      @filterChange="filterChanged"
    />

    <!-- Form -->
    <NicePanel :name="panelName" @close="closeEdit">
      <UserForm @cancel="closeEdit" @success="successEdit" :data="selectedItem"></UserForm>
    </NicePanel>

    <!-- <pre>{{ data }}</pre> -->
  </NiceView>
</template>

<script setup>
import { ref, inject, watch, onMounted } from "vue";

import CommonService from "@/services/common.service";
import ErrorService from "@/services/error.service";
import ApiService from "@/services/api/api.service";
import UserForm from "@/components/forms/UserForm.vue";

import { useGettext } from "vue3-gettext";
const { $gettext } = useGettext();
const $getQuery = inject("getQuery");
const $nice = inject("nice");

import { useRoute, useRouter } from "vue-router";
const route = useRoute();
const router = useRouter();

import { useGeneralStore } from "@/store/general.store";
const generalStore = useGeneralStore();
const permissions = ref(generalStore.permissions);

const data = ref([]);
const loading = ref(false);
const selectedItem = ref(null);
const panelName = "user";

// Watch for id change
watch(
  () => route.query,
  () => {
    if (route.query.id) {
      $nice.panel(panelName, true);
    }
  }
);

onMounted(async () => {
  if (route.query.id) {
    return $nice.panel(panelName, true);
  }
});

function closeEdit() {
  selectedItem.value = null;
  router.push({ query: { ...route.query, id: undefined } });
  $nice.panel(panelName, false);
}

function successEdit() {
  closeEdit();
  getData();
}

function openEdit(item) {
  selectedItem.value = item;
  router.push({ query: { ...route.query, id: item.id } });
}

async function getData() {
  loading.value = true;
  try {
    const query = await $getQuery();
    data.value = await ApiService.users.getAll(route.params.organizationId, query);
  } catch (e) {
    ErrorService.showError(e);
  } finally {
    loading.value = false;
  }
}

const filtersList = [];

function filterChanged() {
  getData();
}

const actions = [
  {
    icon: () => "icon-edit-3",
    function: (v) => openEdit(v),
    disabled: (v) => !permissions.value.can_manage_users || !v.can_edit,
  },
];

const columns = [
  // {
  //   key: "indicator",
  //   class: "w-0 pr-1",
  //   fieldClass: (v, row) => {
  //     return row.active ? "nice-indicator active" : "nice-indicator";
  //   },
  // },
  {
    name: $gettext("Name"),
    key: "user",
    formatter: (v, row) => row.first_name + " " + row.last_name,
    hasOrder: true,
  },
  {
    name: $gettext("Email"),
    key: "email",
    formatter: (v, row) => row.email,
    hasOrder: true,
  },
  {
    name: $gettext("Permissions"),
    key: "permissions",
    html: (v) => {
      let html = "<div class='badges'>";
      for (const [key, value] of Object.entries(v)) {
        if (!value) continue;
        html += `<div class='badge'>${CommonService.getPermission(key).text}</div>`;
      }
      return html + "</div>";
    },
    class: "d-xs-none",
    hasOrder: true,
  },
];
</script>
